import React, { useState, useEffect } from "react";
import { handleGetRequest } from "../../../services/GetTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import "../../../components/DataTable.css";
import AddEditRolesRights from "./AddEditRolesRights";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";

function RoleRights() {
  const history = useHistory();

  const [menu, setMenu] = useState([]);
  const [loading, setloading] = useState([]);
  const [displayModal, setDisplayModal] = useState(false);
  const [setPosition] = useState("center");
  const [editable, setEditable] = useState(false);
  const [roleRightsRowData, setroleRightsRowData] = useState("");
  const { roleId } = useParams();
  const [rows, setRows] = useState(20);
  const [first, setFirst] = useState(0);

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const editHandler = (rowData) => {
    setDisplayModal(true);
    setroleRightsRowData(rowData);
    setEditable(true);
  };

  const getRoleRights = async () => {
    setloading(true);
    const response = await handleGetRequest(
      `zbizgateway/nonFin/getRoleRights/${roleId}`
    );
    setMenu(response?.data);
    setloading(false);
  };

  useEffect(() => {
    getRoleRights();
  }, []); // eslint-disable-line

  const actionTemplate = (rowData) => {
    return (
      <div>
        <Button
          tooltip="Edit"
          icon="pi pi-pencil"
          tooltipOptions={{ position: "top" }}
          onClick={() => editHandler(rowData)}
          className="p-button-rounded p-button-secondary p-mr-2"
        />
      </div>
    );
  };

  const dialogFuncMap = {
    displayModal: setDisplayModal,
  };

  const onClick = (name, position) => {
    dialogFuncMap[`${name}`](true);

    if (position) {
      setPosition(position);
    }
  };

  const onHide = (name) => {
    setDisplayModal(false);
  };

  const authorizeBody = (rowData) => {
    return (
      <React.Fragment>
        {rowData?.authorizeAllowed === "Y" ? "Yes" : "No"}
      </React.Fragment>
    );
  };
  const hideBody = (rowData) => {
    return (
      <React.Fragment>{rowData?.hideYn === "Y" ? "Yes" : "No"}</React.Fragment>
    );
  };
  const insertBody = (rowData) => {
    return (
      <React.Fragment>
        {rowData?.insertAllowed === "Y" ? "Yes" : "No"}
      </React.Fragment>
    );
  };
  const updateBody = (rowData) => {
    return (
      <React.Fragment>
        {rowData?.updateAllowed === "Y" ? "Yes" : "No"}
      </React.Fragment>
    );
  };

  return (
    <div>
      <Dialog
        header={editable ? "Edit Role Rights" : "Add Role Rights"}
        visible={displayModal}
        style={{ width: "50vw" }}
        onHide={() => onHide("displayModal")}
      >
        <AddEditRolesRights
          onHide={onHide}
          editable={editable}
          roleRightsRowData={roleRightsRowData}
          getRoleRights={getRoleRights}
          roleId={roleId}
        />
      </Dialog>
      <div className="page_header">
        <div
          className="Top__Btn"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="d_align">
            <i
              className="pi pi-arrow-circle-left mr-1"
              onClick={() => history.goBack()}
            />
            <h3 className="mod_heading">Role Rights</h3>
          </div>
          <Button
            label="Add New"
            className="Add_New"
            onClick={() => onClick("displayModal", setEditable(false))}
          />
        </div>
      </div>
      <div className="card p-datatable-sm">
        <DataTable
          loading={loading}
          paginator
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rows={rows}
          first={first}
          rowsPerPageOptions={[10, 20, 50, 100, 200]}
          onPage={handlePageChange}
          value={menu}
          emptyMessage="No data found."
        >
          <Column filter field="tblMenu.menuName" header="Decsription" />
          <Column
            filter
            field="authorizeAllowed"
            body={authorizeBody}
            header="Authorization"
          />
          <Column filter field="hideYn" body={hideBody} header="Hidden" />
          <Column
            filter
            field="insertAllowed"
            body={insertBody}
            header="Insert Allowed"
          />
          <Column
            filter
            field="updateAllowed"
            body={updateBody}
            header="Update Allowed"
          />
          <Column body={actionTemplate} header="Action" />
        </DataTable>
      </div>
    </div>
  );
}

export default RoleRights;
